import type { Discount } from '@carvana/merch-contracts';
import DiscountType from '@carvana/merch-contracts/DiscountType';
import { useMemo } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import { useVehiclePaymentTerms } from '~/context/vdp/UserVehicleContext';

export default function useGetRootDiscount(): Discount | null {
  const { enableRootDiscount = false } = useConfiguration();
  const { discounts = [] } = useVehiclePaymentTerms();

  return useMemo<Discount | null>(
    () =>
      enableRootDiscount
        ? discounts.find(
            discount => discount.type === DiscountType.RootTotalLoss
          ) ?? null
        : null,
    [discounts, enableRootDiscount]
  );
}
